<app-entity-crud [config]="config" />
